'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YES = 'Yes';
var NO = 'No';

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module0App2 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    app: state.moduleData.data.module0.app2,
    allModule: state.moduleData.data.module1,
    profile: state.profile.data
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module0App2, _Component);

  function Module0App2() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module0App2);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module0App2.__proto__ || (0, _getPrototypeOf2.default)(Module0App2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 1,
      appId: 2,
      seen: _this.props.app.seen || '',
      whereSeen: _this.props.app.whereSeen || '',
      useGuide: _this.props.app.useGuide || '',
      isCompleted: _this.props.app.isCompleted || false
    }, _this.handleBool = function (str, event) {
      var obj = _this.state;

      if (str === 'seen') {
        obj.seen = event.target.value;
        if (obj.seen === NO) {
          obj.useGuide = '';
        }
      }

      if (str === 'guide') {
        obj.useGuide = event.target.value;
      }

      _this.setState(obj);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      // this.props.updateModuleApp(this.props.user.userId, this.state.moduleId, this.state.appId, this.state);
      _this.props.updateModuleApp(_this.props.user.userId, 0, 2, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * User clicks on Yes or No for have they
   * seen a dietician
   */


  /*
   * User types in something for what was
   * involved in the diet
   */


  /*
   * Handle when user finishes this module
   */


  (0, _createClass3.default)(Module0App2, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');
      var pyramidImage = require('../Assets/pyramid.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Getting Ready'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'What do you already know?'
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 7 },
              _react2.default.createElement(
                'h5',
                null,
                'Have you seen this food pyramid before?'
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { onChange: this.handleBool.bind(this, 'seen') },
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'seen', value: 'Yes', checked: this.state.seen === 'Yes' || this.state.seen == 1 },
                  'Yes'
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'seen', value: 'No', checked: this.state.seen === 'No' || this.state.seen == 0 },
                  'No/Unsure'
                )
              ),
              (this.state.seen === YES || this.state.seen == 1) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'Where have you seen it?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  null,
                  _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text', placeholder: 'Where have you seen this food pyramid?',
                    value: this.state.whereSeen, onChange: this.handleChange.bind(this, 'whereSeen') })
                )
              ),
              (this.state.seen === YES || this.state.seen == 1) && this.state.whereSeen && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'Have you used it to guide what you give ',
                  this.props.profile.childName,
                  '?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleBool.bind(this, 'guide') },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'guide', value: 'Yes', checked: this.state.useGuide === 'Yes' || this.state.useGuide == 1 },
                    'Yes'
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'guide', value: 'No', checked: this.state.useGuide === 'No' || this.state.useGuide == 0 },
                    'No/Unsure'
                  )
                )
              ),
              _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 5 },
              _react2.default.createElement(ReactBootstrap.Image, { src: pyramidImage, responsive: true })
            ),
            _react2.default.createElement('div', { className: styles.spacer100 })
          )
        )
      );
    }
  }]);
  return Module0App2;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  updateModuleApp: _propTypes2.default.func,
  updateModule: _propTypes2.default.func,
  changeItem: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = Module0App2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/0/App/App2.js
// module id = 1154
// module chunks = 0